import React from "react";
import StickyHeaderDataTable from "../shared/sticky-header-data-table";

import Box from "@mui/material/Box";

import Loader from "../loader";

const totalRowStyles = [
  {
    when: (row) => row.isTotal,
    style: {
      fontWeight: "bold",
      borderTop: "2px solid #ccc",
      backgroundColor: "#f7f7f7",
    },
  },
];

export const MetricsSalesTable = ({
  title,
  columns,
  rows = [],
  totals,
  isLoading,
  pagination,
  sorting,
  onPage,
  onRowsPerPage,
  onSort,
}) => {
  const data = totals
    ? [...rows, { ...totals, rep: "Total", isTotal: true, ownerId: "__total__" }]
    : rows;

  return (
    <Box>
      <h5>{title}</h5>

      <div className="server-pagination-table-container metrics-table-container data-table-compact-view shadow-none mt-2">
        <StickyHeaderDataTable
          className="metrics-table"
          columns={columns}
          data={data}
          conditionalRowStyles={totalRowStyles}
          persistTableHead
          progressPending={isLoading}
          progressComponent={<Loader additionalClasses="metrics-table-loader" />}

          pagination
          paginationServer
          paginationTotalRows={pagination.totalItems}
          paginationPerPage={pagination.countPerPage}
          paginationDefaultPage={pagination.currentPage}
          paginationRowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]}
          onChangePage={onPage}
          onChangeRowsPerPage={onRowsPerPage}
          paginationResetDefaultPage={false}

          sortServer
          onSort={onSort}
          defaultSortField={sorting.sortBy}
          sortDirection={sorting.sortDirection}
        />
      </div>
    </Box>
  );
};
